import { type FC } from 'react';

import { toast } from 'sonner';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';
import { truncateMidAddressInputValue } from '@/utils/truncateAddress';

import { useConnectEvmWallet, useWatchAccountEvents } from '../../hooks';

import { ConnectedEvmWalletButton } from './components';

export const ConnectedEvmWallet: FC<ButtonProps> = ({ className, children, ...props }) => {
  const { connect, isConnected } = useConnectEvmWallet();

  useWatchAccountEvents((account, previousAccount) => {
    if (account.address && previousAccount.address) {
      if (previousAccount.address !== account.address) {
        void toast.success(`Account changed to ${truncateMidAddressInputValue(account.address, 16)}`);
      }
    } else if (account.address && !previousAccount.address) {
      void toast.success(`Account connected: ${truncateMidAddressInputValue(account.address, 16)}`);
    } else if (!account.address && previousAccount.address) {
      void toast.success(`EVM Wallet disconnected`);
    }
  });

  if (!isConnected) {
    return (
      <Button
        variant="secondary"
        size="sm"
        className={cn('font-cocogoose rounded-xl text-sm font-bold', className)}
        onClick={() => {
          connect();
        }}
        {...props}
      >
        {children || 'Connect EVM Wallet'}
      </Button>
    );
  }

  return (
    <ConnectedEvmWalletButton {...props} className={className}>
      {children}
    </ConnectedEvmWalletButton>
  );
};
